import { axiosInstance } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";

const listOffers = async (velId) => {
  const { data } = await axiosInstance.get(
    `/api/abo/vel/${velId}/offer`
  );
  return data;
};

export const useOfferList = ({velId}) => {
  return useQuery({
    queryKey: ["vel", velId, 'offers'],
    queryFn: () => listOffers(velId),
    enabled: !!velId
  });
};
